var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_c('div',{attrs:{"id":"pdf-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }